import { configureStore } from '@reduxjs/toolkit';

import { baseProtectedApi, basePublicApi } from './baseApi';
import authReducer from './slices/authSlice';

const store = configureStore({
  reducer: {
    auth: authReducer,
    [basePublicApi.reducerPath]: basePublicApi.reducer,
    [baseProtectedApi.reducerPath]: baseProtectedApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(basePublicApi.middleware, baseProtectedApi.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
